var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-1 app-font-size",attrs:{"color":"primary","dark":"","app":_vm.$vuetify.breakpoint.smAndUp}},[_c('v-flex',{attrs:{"text-center":""}},[_c('span',[_vm._v(" © "+_vm._s(_vm.$t('footerLabels.mainFooterLabel', [_vm.getCurrentYear]))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }